import pl from "@locales/patient/health_and_goal/dietary_profile_tab/pl.json";
import en from "@locales/patient/health_and_goal/dietary_profile_tab/en.json";

export default {
  pl: pl,
  en: en,
};
